export default __webpack_public_path__ + "static/media/dinheiro-todo-seu.162e5353.png";